import '../App.css';
import {Title} from "./Title";

export const InformationBlock = ({name, text}) => {
    return (
        <div className={'information-block-' + name.toLowerCase()}>
            <div className={'title-information-block'}>
                <Title name={name}/>
                <div className={'top-border-line'}></div>
            </div>
            {text}
        </div>
    )
}
